import { app } from '../app';

import { HomeController } from './home-controller';

app.init().controller('fcHomeController', HomeController);
